// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__3syJO","content":"LoadingAlert_content__1CuUw"};